import { colors } from "../../../styles/figmaColors";
import { useTranslation } from "react-i18next";
import {
  LockOutlined,
  NotInterestedOutlined,
  TaskAltOutlined,
  WatchLaterOutlined,
} from "../../materialUi/materialUi";
import { Tag } from "../Tag/Tag";
import "../../../../i18n/i18n";

type Status =
  | "ACTIVE"
  | "IN_OPPOSITION"
  | "TO_ACTIVATE"
  | "LOCKED"
  | "INACTIVE_PIN_ONLINE"
  | "BLOCKED_PIN_OFFLINE";
const statusEnum = [
  "ACTIVE",
  "IN_OPPOSITION",
  "TO_ACTIVATE",
  "LOCKED",
  "INACTIVE_PIN_ONLINE",
  "BLOCKED_PIN_OFFLINE",
];

const statusProps = {
  ACTIVE: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
    iconColor: colors["colors/system/success/success_normal"],
    iconLeft: <TaskAltOutlined />,
  },
  IN_OPPOSITION: {
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_normal"],
    iconColor: colors["colors/system/error/error_normal"],
    iconLeft: <NotInterestedOutlined />,
  },
  TO_ACTIVATE: {
    backgroundColor: colors["colors/system/informative/informative_ultraLight"],
    textColor: colors["colors/system/informative/informative_normal"],
    iconColor: colors["colors/system/informative/informative_normal"],
    iconLeft: <WatchLaterOutlined />,
  },
  LOCKED: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/black"],
    iconColor: colors["colors/text/black"],
    iconLeft: <LockOutlined />,
  },
  INACTIVE_PIN_ONLINE: {
    backgroundColor: colors["colors/system/warning/warning_ultraLight"],
    textColor: colors["colors/system/warning/warning_normal"],
    iconColor: colors["colors/system/warning/warning_normal"],
    iconLeft: <LockOutlined />,
  },
  BLOCKED_PIN_OFFLINE: {
    backgroundColor: colors["colors/system/warning/warning_ultraLight"],
    textColor: colors["colors/system/warning/warning_normal"],
    iconColor: colors["colors/system/warning/warning_normal"],
    iconLeft: <LockOutlined />,
  },
};

export const TableTagCard = (props: { status: Status }) => {
  const { t } = useTranslation();
  const statusTranslated = statusEnum.find(
    (s) => props.status === s || t(`cards.status.${s}`) === props.status,
  );
  if (!statusTranslated) {
    return null;
  }
  const cardStatus = statusProps[statusTranslated as Status];
  const label = t(`cards.status.${statusTranslated}`) ?? props.status;

  return (
    <Tag
      text={label}
      backgroundColor={cardStatus.backgroundColor}
      textColor={cardStatus.textColor}
      iconColor={cardStatus.iconColor}
      //iconLeft={cardStatus.iconLeft}
    />
  );
};
